export default "__VITE_ASSET__Ze35Opbf__"